const SeoCodes = Object.freeze({
    Home: "home",
    AboutUs: "about",
    ContactUs: "contact-us",
    Blogs : "blogs",
    Companies : "companies-services",
    Courses : "all-courses",
    Posts : "posts",
    ReviewsPage: "review",
    OurPartners: "partners",
    OurClients: "clients",
    FAQ: "faq",
    TermsAndConditions: "terms",
    Login: "login",
    Diplomas: "all-diplomas"
   
})

export default SeoCodes